import { useState } from "react";
import { toast, Toaster } from "react-hot-toast";
import { fetchRS } from "../../utils/fetchRS";


export const ReportesS3 = () => {
  const [selectedDate, setSelectedDate] = useState(() => new Date().toISOString().split("T")[0]);

  const [reportUrl, setReportUrl] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    if (!selectedDate) {
      toast.error("Por favor, seleccione la fecha.");
      return;
    }

    setLoading(true);
    setReportUrl("");

    try {
      const res = await fetchRS(`${process.env.REACT_APP_API_URL}/reports/reportes?date=${selectedDate}`);


      console.log("data", res)
      setReportUrl(res.url);
      toast.success("Reporte cargado.");
    } catch (err) {
      toast.error(err as string || "Error de conexión.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-gray-100">
      <Toaster
        position="top-center"
        toastOptions={{ style: { marginTop: "40vh" } }}
      />

      <div className="bg-white p-6 rounded-md shadow-md">
        <h3 className="text-base font-semibold mb-6 mt-2 text-center">
          Alertas De Sistemas De Pesaje De Leche
        </h3>

        {}
        <div className="d-flex justify-content-center pt-4">


          <div className="col-lg-3">
            <div className="form-floating mb-3">
              <input
                type="date"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
                className="form-control form-control-lg"
              />
              <label htmlFor="selectedDate">Fecha:</label>
            </div>
          </div>
      </div>

        <button
          onClick={fetchReport}
          disabled={loading}
          className="w-full py-2 px-4 mt-4 rounded-lg text-white font-semibold transition duration-300"
          style={{
            backgroundColor: loading ? "#FF6699" : "#FF6699",
            cursor: loading ? "not-allowed" : "pointer",
            border: "none",
          }}
        >
          {loading ? "Cargando..." : "📥 Ver Reporte"}
        </button>

        {}
        {reportUrl && (
          <div className="w-full h-screen bg-gray-100 flex justify-center items-center mt-6">
            <iframe
              src={reportUrl}
              title="Reporte Individual"
              className="w-full h-full border-none"
            />
          </div>
        )}
      </div>
    </div>
  );
};
